(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fctr-shop-finds"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fctr-shop-finds')) {
    customElements.define('fctr-shop-finds', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const cards = Array.from(this.querySelectorAll('[data-fctr-product]'));
        const buttons = Array.from(this.querySelectorAll('[data-fctr-filter]'));
        const filters = this.querySelector('.fctr-finds__filters');
        if (!filters || !cards.length) return;
        filters.hidden = false;
        buttons.forEach(button => {
          const category = button.dataset.fctrFilter;
          button.hidden = category !== 'all' && !cards.some(card => card.dataset.audience === category || card.dataset.audience === 'all');
          button.addEventListener('click', () => {
            let count = 0;
            buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
            cards.forEach(card => {
              card.hidden = category !== 'all' && card.dataset.audience !== category && card.dataset.audience !== 'all';
              if (!card.hidden) count += 1;
            });
            const status = this.querySelector('[data-fctr-status]');
            if (status) status.textContent = this.dataset.resultsLabel.replace('__COUNT__', String(count));
          }, { signal: this.controller.signal });
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fctr-overlay-video-toggle')) {
    customElements.define('fctr-overlay-video-toggle', class extends HTMLElement {
      connectedCallback() {
        const video = this.closest('.fctr-media-overlay')?.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => {
          button.toggleAttribute('data-paused', video.paused);
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const respectMotion = () => {
          if (motion.matches) {
            video.autoplay = false;
            video.pause();
          }
        };

        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(update);
          } else {
            video.pause();
          }
        }, options);
        video.addEventListener('play', update, options);
        video.addEventListener('pause', update, options);
        motion.addEventListener('change', respectMotion, options);
        respectMotion();
        update();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
